import type { FaireProductEntity } from "../../entity_types/product";

export const p_de4qzf6ynd: FaireProductEntity = {
  token: "p_de4qzf6ynd",
  type: "product",
  name: "OJAI NUIT",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/510d572c1d1a61e6b7f62a933294cd20aef6cd06eba3daf1c11f52b90ba1f198.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ed77bb38f5f7010403b91c257fdb47b60015ebae30108b2dbcc4f54d2ccb86f.jpeg",
    "https://cdn.faire.com/fastly/ad37dbafe104065280142b44a7cee2529929be0ab739c88928649491a0b1ab04.jpeg",
    "https://cdn.faire.com/fastly/49a100e47d2744545ab531b8de5425576da0e871daa251df210712e26bcf4bf9.jpeg",
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/91538945e68e2834daa9354e9822ea6f63123c9ac5c9f9bbc7b501e2575d4e33.jpeg",
  ],
  priceDollars: 19,
  description:
    "Reminiscent of a summer getaway spent in Ojai, this scent will transport you to a night under the stars with the clean scent of balsam fir and sandalwood balanced beautifully with airy top notes of fresh fig tree.\n\nbalsam fir, fig leaf, sandalwood, amber\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8.4 ounces (228g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T14:47:19.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
